import React from "react";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleScrollTo = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) section.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="backdrop-blur-md bg-black/20 text-white border-t border-white/10">
      <div className="container mx-auto px-4 py-12 flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-20 text-center lg:text-left">
        {/* Logo + Contatti */}
        <div
          className="flex flex-col items-center lg:items-start cursor-pointer"
          onClick={() => handleScrollTo("home")}
        >
          <div className="flex flex-col leading-none select-none items-center lg:items-start">
            <span className="logo-vision">VISION</span>
            <span className="logo-design">DESIGN</span>
          </div>

          <div className="opacity-80 text-gray-300 mt-4 leading-relaxed text-center lg:text-left">
            <p className="text-sm md:text-base">
              <strong>{t("footer.email")}:</strong> info.visiondesign90@gmail.com
            </p>
            {/* <p className="text-sm md:text-base">
              <strong>{t("footer.phone")}:</strong> +39 327 950 7406
            </p> */}
            <p className="text-sm md:text-base">
              <strong>{t("footer.country")}:</strong> {t("footer.countryName")}
            </p>
          </div>
        </div>

        {/* Link alle sezioni */}
        <div className="font-audiowide flex items-center">
          <ul className="flex flex-col lg:flex-row items-center justify-center space-y-2 lg:space-y-0 lg:space-x-16">
            {["about", "skills", "projects", "contacts"].map((section) => (
              <li key={section}>
                <button
                  onClick={() => handleScrollTo(section)}
                  className="text-base lg:text-lg hover:text-purple-300 transition-colors"
                >
                  {t(`nav.${section}`)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Social */}
        <div className="flex justify-center items-center space-x-6">
          <a href="/" className="hover:text-purple-300 transition-colors">
            <FaGithub size={24} />
          </a>
          <a href="/" className="hover:text-purple-300 transition-colors">
            <FaLinkedin size={24} />
          </a>
          <a href="/" className="hover:text-purple-300 transition-colors">
            <FaInstagram size={24} />
          </a>
        </div>
      </div>

      <div className="py-4">
        <p className="text-center text-sm opacity-80 px-4">
          &copy; {new Date().getFullYear()} VisionDesign. {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
